module.exports = __webpack_public_path__ + "img/chart.e43f5c6b.png";